// extracted by mini-css-extract-plugin
module.exports = {"navbar":"navbar__navbar__2EPET","logo":"navbar__logo__2Tw3_","nav_item":"navbar__nav_item__2TUA9"};